import { FieldState } from 'support/types/ui';

import { DiffStatus } from '../types';

export const shouldShowDiff = (diffStatus: DiffStatus | undefined, fieldState: FieldState): boolean =>
  Boolean(diffStatus && fieldState !== 'error' && fieldState !== 'pending-validation' && fieldState !== 'warning');
